import React from 'react';

function Flex(
  {
    direction,
    className,
    children,
    style,
    ...props
  }: {
    direction?: 'row' | 'column',
    className?: string,
    children?: React.ReactNode,
    style?: React.CSSProperties,
  },
  ref: React.Ref<HTMLDivElement>,
) {
  return (
    <div
      ref={ref}
      style={{display: 'flex', flexDirection: direction, ...style}}
      className={className}
      {...props}>
      {children}
    </div>
  );
}

export default React.forwardRef(Flex);
